import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, of } from 'rxjs';
import { SharedService } from './shared.service';
import { take, concatMap, finalize, first, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PrintService {
  constructor(public httpClient: HttpClient,
    private sharedService: SharedService) {
  }

  mapIdsToLabelsForPolicy(policyPrintObject) {
    /*return forkJoin(
      this.sharedService.vehicleDamagesEnum$.pipe(take(1)),
      this.sharedService.vehicles.pipe(take(1)),
      this.sharedService.insuredVehicleData.pipe(take(1)),
      this.sharedService.getAdditionalInfo(null).pipe(take(1)),
      this.sharedService.vehicleRegType$.pipe(take(1)),
      this.sharedService.postcodes$.pipe(take(1)),
      this.sharedService.vehicleDamagesForPrinting$.pipe(take(1)),
      this.sharedService.vehicleUsages$.pipe(take(1)),
      this.sharedService.beneficiaryInCase$.pipe(take(1))
      )
      .pipe(
        concatMap(([vehicleDamages, vehicles, vehicleEnums, additionalInfo, vehicleRegistrations, postCodes, vehicleDamagesForPrinting, vehicleUsages, beneficiaryInCase]) => {
          const typeId = policyPrintObject.vehicleDTO.typeId;
          const makeId = policyPrintObject.vehicleDTO.makeId;
          const modelId = policyPrintObject.vehicleDTO.modelId;
          const vehicleTypeData = vehicles.find(x => x.typeId === typeId);
          if (vehicleTypeData) {
            const makeData = vehicleTypeData.makeAndModels.find(x => x.makeId === makeId);
            const modelData = makeData.models.find(x => x.modelId === modelId);
            policyPrintObject.greenCardCertObject = {
              greenCardCert: {
                gcNumber: policyPrintObject.greenCardCert.gcNumber,
                validFrom: policyPrintObject.greenCardCert.validFrom,
                validTo: policyPrintObject.greenCardCert.validTo,
                vehicleCategory: vehicleTypeData.typeName
              }
            }
            policyPrintObject.vehicleDTO.typeId = vehicleTypeData.typeName;
            policyPrintObject.vehicleDTO.makeId = makeData.makeName;
            policyPrintObject.vehicleDTO.modelId = modelData.modelName;
          }

          policyPrintObject.vehicleDTO.colorId = vehicleEnums['vehColors'].find(x => x.value === policyPrintObject.vehicleDTO.colorId).label;
          policyPrintObject.vehicleDTO.carUsageId = vehicleUsages.find(x => x.value === policyPrintObject.vehicleDTO.carUsageId).label;

          if(policyPrintObject.companyBeneficiaryData){
            policyPrintObject.companyBeneficiaryData.beneficiaryData.inCaseId = beneficiaryInCase.find(x => x.value === policyPrintObject.companyBeneficiaryData.beneficiaryData?.inCaseId).label;
          }


          policyPrintObject.vehicleDamages.forEach(vehicleDamage => {
            const damageLabel = vehicleDamages.damageDetails.find(x => vehicleDamage.detailId === x.value);
            const severityLabel = vehicleDamagesForPrinting.find(x => vehicleDamage.damageSeverityId === x.value);
            vehicleDamage.detailId = damageLabel && damageLabel.label;
            vehicleDamage.damageSeverityId = severityLabel && severityLabel.label;
          });

          const claimType = policyPrintObject.claimType && additionalInfo.compensationMethod.find(x => x.value === policyPrintObject.claimType);
          policyPrintObject.claimType = claimType && claimType.label;

          const regType = policyPrintObject.vehicleDTO.regTypeId && vehicleRegistrations.find(x => x.value === policyPrintObject.vehicleDTO.regTypeId);
          policyPrintObject.vehicleDTO.regTypeId = regType && regType.label;

          if (policyPrintObject.personInsurerData && policyPrintObject.personInsurerData.city) {
            var town = postCodes.find(x => x.forId === policyPrintObject.personInsurerData.city);
            if (town)
              policyPrintObject.personInsurerData.city = town.label;
          }

         /!* if (policyPrintObject.companyInsurerData && policyPrintObject.companyInsurerData.city) {
            var town = postCodes.find(x => x.forId === policyPrintObject.companyInsurerData.city);
            if (town)
              policyPrintObject.companyInsurerData.city = town.label;
          }*!/

          if (policyPrintObject.personPayerData && policyPrintObject.personPayerData.city) {
            var town = postCodes.find(x => x.forId === policyPrintObject.personPayerData.city);
            if (town)
              policyPrintObject.personPayerData.city = town.label;
          }

          /!*if (policyPrintObject.companyPayerData && policyPrintObject.companyPayerData.city) {
            var town = postCodes.find(x => x.forId === policyPrintObject.companyPayerData.city);
            if (town)
              policyPrintObject.companyPayerData.city = town.label;
          }*!/

          if (policyPrintObject.personOwnerData && policyPrintObject.personOwnerData.city) {
            var town = postCodes.find(x => x.forId === policyPrintObject.personOwnerData.city);
            if (town)
              policyPrintObject.personOwnerData.city = town.label;
          }

          if (policyPrintObject.companyOwnerData && policyPrintObject.companyOwnerData.city) {
            var town = postCodes.find(x => x.forId === policyPrintObject.companyOwnerData.city);
            if (town)
              policyPrintObject.companyOwnerData.city = town.label;
          }

          return of(policyPrintObject);
        })
      );*/
  }

  private preparePrintObject(policy, response) {
    const policyPrintObject = Object.assign({}, policy, response);
    let policyToPrint = this.mapIdsToLabelsForPolicy(JSON.parse(JSON.stringify(policyPrintObject)));
    return policyToPrint;
  }

  printPolicy(data) {
    /*this.preparePrintObject(data.policy, data.response).subscribe((res) => {
      this.httpClient.post(`/api/v1/pdf/print-policy`, res, { responseType: 'text', observe: 'response' }).subscribe((res: any) => {
        const byteCharacters = atob(res.body);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        let URLObject = URL.createObjectURL(blob);
        window.open((URLObject), '_blank');
      });
    });*/
  }
}
